/**
 *  Initialize Announcement Bar
 */

var announcementBar = (function() {
	var pub = {}; // public facing functions

	pub.init = function () {
		announcementBarListener();
		$('[data-close-announcement]').click(function(event) {
		  event.preventDefault();
		  var $btn = $(this);
		  var target = $btn.attr('data-close-announcement');
		  var $announcement = $(document).find(target);
		  $announcement.addClass('is-collapsed');
		});
	};

	pub.getAnnouncementBar = function (type, codename) {
		if (!codename)
			codename = "";
		var userClickedBars = getUserClickedBars();
		$.get('/Pages/GetAnnouncementBar?type=' + type + '&relatedto=' + codename + '&userClickedBars=' + userClickedBars, function (data) {
			//Returned data is the partial view of the announcement bar if we need to show the bar, else returned data is empty
			$("#div_announcementBar").html(data);
			updateNavBarPosition();
			countDownTimer("#div_announcementBar");
		});
	};

	function updateNavBarPosition() {
		var barHeight = $("#div_announcementBar").height();
		$('.nav').css('top', barHeight + 'px');
	}

	function announcementBarListener() {
		var userClickedBars = getUserClickedBars();

		//Click event for X button on announcement bar
		$(document).on('click', '.announcement-bar__close-btn', function (e) {
			var newBarCodename = $('#announcementBar_codename').html();
			if (userClickedBars.indexOf(newBarCodename) < 0) {
				updateUserClickedBars(newBarCodename);
			}
			$('.nav').css('top', '0px');
			$('#announcement-bar').remove();
		});

		$(window).resize(function (e) {
			updateNavBarPosition();
		});
	}

	function getUserClickedBars() {
		var bars = [];
		try {
			bars = JSON.parse(localStorage.getItem("hideAnnouncementBar"));
		} catch (e) {
			bars = [];
		}
		if (bars === null)
			bars = [];
		return bars;
	}

	function updateUserClickedBars(newValue) {
		var bars = getUserClickedBars();
		bars.push(newValue);
		localStorage.setItem("hideAnnouncementBar", JSON.stringify(bars));
	}

	function getTimeRemaining(endtime) {
		var t = Date.parse(endtime) - Date.parse(new Date());
		var seconds = Math.floor((t / 1000) % 60);
		var minutes = Math.floor((t / 1000 / 60) % 60);
		var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
		var days = Math.floor(t / (1000 * 60 * 60 * 24));

		return {
			total: t,
			days: days,
			hours: hours,
			minutes: minutes,
			seconds: seconds
		};
	}

	function countDownTimer(target) {
		var endtime = $(target).find(".countdown").text()

		if (endtime) {
			var clock = $(target).find(".announcement-bar__countdown");
			var daysSpan = clock.find('.days');
			var hoursSpan = clock.find('.hours');
			var minutesSpan = clock.find('.minutes');
			var secondsSpan = clock.find('.seconds');

			function updateClock() {
				var t = getTimeRemaining(endtime);

				daysSpan.text(t.days);
				hoursSpan.text(('0' + t.hours).slice(-2));
				minutesSpan.text(('0' + t.minutes).slice(-2));
				secondsSpan.text(('0' + t.seconds).slice(-2));

				if (t.total <= 0) {
					clock.html("");
					clearInterval(timeinterval);
				}
			}

			updateClock();
			var timeinterval = setInterval(updateClock, 1000);
		}
	}

  return pub;
})();
